import React, { Component } from "react";

// React router
import { withRouter } from "react-router-dom";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Dependencies
import _ from "lodash";
import PropTypes from "prop-types";

// Material ui
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";

//constants
import { SALES_SUBDOMAIN } from "../../constants";

// Shared layouts
import { Dashboard as DashboardLayout } from "layouts";
import { SearchInput } from "components";
import { ConnectionsList } from "./components";
import { fetchConnections } from "../../redux/actions/connectionActions";

import styles from "./styles";
import { triggerBotBuilding } from "../../redux/actions/intentsActions";
import { pushMessage, removeMessage } from "../../redux/actions/commonActions";

class Connections extends Component {
  signal = true;

  state = {
    isLoading: false,
    limit: 6,
    products: [],
    productsTotal: 0,
    error: null,
    search: "",
    loaded: false,
    connections: {},
    disabled: false
  };

  async getConnections() {
    try {
      this.setState({ isLoading: true });
      // console.log("Check bot status");
      await this.props.fetchConnections();
      this.setState({ isLoading: false, loaded: true });
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          loaded: true,
          error
        });
      }
    }
  }

  componentWillMount() {
    this.signal = true;
    this.getConnections();
  }

  componentWillUnmount() {
    this.signal = false;
  }

  componentWillReceiveProps(newProps, oldProps) {
    this.setState({ connections: newProps.connections });
  }

  filterConnections = (event, val) => {
    this.setState({ search: event.target.value });
    let connectionLists = { ...this.state.connections };
    _.forEach(connectionLists, (connections, key) => {
      // Ignore fallbackIntent since it does not contain a list of connectors (it contains fallback intent data)
      if (key === "fallbackIntent") {
        return;
      }

      _.forEach(connections, connection => {
        connection.visible = _.includes(connection.connectorName.toLowerCase(), event.target.value.toLowerCase());
      });
    });
    this.setState({ connections: connectionLists });
  };

  onBuildBotClick = () => {
    this.setState({ disabled: true });
    this.props.triggerBotBuilding();
  };

  render() {
    const { classes } = this.props;

    const enabled = this.state.connections["enabled"] ? this.state.connections.enabled : [];
    const common = this.state.connections["common"] ? this.state.connections.common : [];

    return (
      <DashboardLayout title="Connections" isLoading={this.state.isLoading}>
        <Grid spacing={2} container>
          <Grid item xs={12} sm={3}>
            <SearchInput
              value={this.state.search}
              className={classes.searchInput}
              onChange={this.filterConnections}
              placeholder="Search Connections"
            />
          </Grid>
          {(this.props.administrator&&this.props.appType!==SALES_SUBDOMAIN) ? (
            <Grid item xs={12} sm={9}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.onBuildBotClick}
                disabled={this.props.botBuildTriggered}
              >
                BUILD RESPONSUM
              </Button>
            </Grid>
          ) : ( <Grid item xs={12} sm={9} /> )}
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <div className={classes.listClass}>
              <ConnectionsList connections={enabled} enabled={enabled} name={"Enabled Connectors"} showBadge={true} />
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <div className={classes.listClass}>
              <ConnectionsList connections={common} enabled={enabled} name={"Available Connectors"} />
            </div>
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }
}

Connections.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchConnections: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    connections: state.connections ? state.connections : {},
    skill: state.skill,
    botBuilt: state.intents["botBuilt"] ? state.intents.botBuilt : {},
    botStatus: state.intents["botStatus"] ? state.intents.botStatus : {},
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false,
    message: state.common.message,
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator",
    appType: state.common.appType??null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchConnections,
        triggerBotBuilding,
        removeMessage,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Connections))
);
